module.exports = __webpack_public_path__ + "static/media/Nutztierverkauf.e653b87f.png";